import axiosTokenInstance from 'services/api/backoffice';
import { IFT_REPORT, IFT_REPORT_ERROR } from '_models/redux/types';

// Action function
export const getIftReportAction = (params) => async (dispatch) => {
  const { from_time, to_time } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `api/reports/ift?from_date=${from_time}&to_date=${to_time}`,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'get',
      payload: data || {},
      status: status || {},
      type: IFT_REPORT,
    });
  } catch (e) {
    dispatch({
      method: 'get',
      payload: e || {},
      type: IFT_REPORT_ERROR,
    });
  }
};
